import React from 'react';
import { DropTarget } from 'react-dnd';
// import { toJS } from 'mobx';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import pubSub from '../../utils/pubSub';
// import defaultFormatDate from '../../utils/defaultFormatDate';
import stores from '../../store/index';
import DayEmployees from './DayEmployees';
import getItemPosition from './getItemPosition';

const spec = {
  drop(props, monitor, component) {
    if (monitor.getItemType() === 'day') {
      const { shift, employee } = monitor.getItem();

      if (props.item.id === shift.id) {
        return;
      }

      Promise.all([
        stores.planStore.addEmployee(employee.id, props.item.id),
        stores.planStore.removeEmployee(employee.id, shift.id),
      ]).then(() => {
        // pubSub.publish('fetch:day', props.day);
      }).catch(() => {
        toast.error('Het verplaatsen van een medewerker is mislukt');
      });

      return;
    }

    const { id } = monitor.getItem();
    stores.planStore.addEmployee(id, props.item.id);
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

const DayGraphLine = ({ day, item, isOver, onEdit, connectDropTarget }) => {
  const { width, x } = getItemPosition(item, day.date);

  let className = '';

  if (isOver) {
    className += ' is-over';
  }

  if (width + x >= 100) {
    className += ' is-end';
  }

  if (x <= 0) {
    className += ' is-start';
  }

  return connectDropTarget(
    <div key={item.id} className="DayGraph__Line">
      <div className={`DayGraph__Item ${className}`} style={{ width: `${width}%`, left: `${x}%` }}>
        <div className="DayGraph__Times">
          {item.startDateTime} {(item.startDateTime) ? '–' : ''} {item.endDateTime}
        </div>

        <strong className="DayGraph__Title">
          {item.projectIdentifier === '' ? item.projectIdentifier : null} {item.projectName}
        </strong>

        {item.shiftName}

        <DayEmployees item={item} shift={item} />

        <button
          className="DayGraph__ItemRemove"
          type="button"
          aria-label="Bewerken"
          onClick={onEdit}
        >
          <FontAwesomeIcon icon="pen" />
        </button>
      </div>
    </div>
  );
};

export default DropTarget(['day', 'group'], spec, collect)(DayGraphLine);



// WEBPACK FOOTER //
// ./src/components/DayModal/DayGraphLine.js